import { InfoIcon, OctagonAlert, TriangleAlert } from "lucide-react";

const SeverityIcon = {
  info: <InfoIcon />,
  warning: <TriangleAlert />,
  critical: <OctagonAlert />,
};

export const AlertIcon = ({ severity }) => {
  // Colors need to be defined using rgba for compatibility
  const severityColors = {
    info: {
      background: "rgba(96, 165, 250, 0.08)",
      borderColor: "rgba(96, 165, 250, 0.05)",
      color: "rgba(96, 165, 250, 1)",
    },
    warning: {
      background: "rgba(251, 146, 60, 0.08)",
      borderColor: "rgba(251, 146, 60, 0.05)",
      color: "rgba(251, 146, 60, 1)",
    },
    critical: {
      background: "rgba(244, 63, 94, 0.08)",
      borderColor: "rgba(244, 63, 94, 0.05)",
      color: "rgba(244, 63, 94, 1)",
    },
  };

  return (
    <div
      className={
        "rounded-lg border flex items-center justify-center flex-shrink-0 w-8 h-8 md:h-10 md:w-10 mt-1"
      }
      style={severityColors[severity] || severityColors["critical"]}
    >
      {SeverityIcon[severity]}
    </div>
  );
};
